<template>
    <div class="col-sm-9">
        <div class="new_soproni_small_area">
            <div class="row">
                <div class="col-sm-12">
                    <div class="section_title_box">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="section_title">
                                    <div class="section_title_cont text-left" style="display:inline-box">
                                        <h3>KOSÁR<span style="float:right;margin-right:25px;cursor:pointer;" onclick="window.history.back();">VISSZA</span></h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row">
                <div class="col-sm-12">
                    <div class="ked_menu_box">
                        <div class="ked_menu_box_cont">
                            <div class="row">
                                <div class="col-sm-2">
                                    <div class="dust_box">
                                        <div class="dust_cont_box">
                                            <div class="bin_image" @click="clearBasket">
                                                <img src="images/been.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-10">
                                    <div class="ked_menu">
                                        <div class="ked_menu_cont">
                                            <ul>
                                                <li class="col-sm-1">Terméknév</li>
                                                <li class="col-sm-1">Bruttó egységár</li>
                                                <li class="col-sm-1">Mennyiség</li>
                                                <li class="col-sm-1">ÖSSZEG</li>
                                                <li class="col-sm-1">Bruttó tömeg és költség</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row" v-for="be in basket.basketElements">
                <div class="kedvenciam_all_area">
                    <div class="col-sm-12">
                        <div class="single_kedvenciam_all">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="tick_box">
                                        <div class="dust_chq_box">
                                            <div class="bin_image" @click="removeElement(be)">
                                                <img src="images/been.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="kedvenciam_all_small_can">
                                        <img :src="be.product.imageUrl" alt="">
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="kedvenciam_all_small_title">
                                        <h6>{{be.product.name}}</h6>
                                    </div>
                                </div>
                                <div class="col-sm-1">
                                    <div class="kedvenciam_all_quantity_small_title">
                                        <p>{{be.product.price && be.product.price.toLocaleString('hu')}} Ft</p>
                                    </div>
                                </div>
                                <div class="col-sm-2">

                                    <div class="small_quantity_count">
                                        <div class="input-group spinner">
                                            <input v-model="be.quantity" type="number" class="form-control" disabled style="width:100%;">
                                            <div class="input-group-btn-vertical">
                                              <button class="btn btn-default" type="button" @click="increment(be)"><i class="fa fa-caret-up"></i></button>
                                              <button class="btn btn-default" type="button" @click="decrement(be)"><i class="fa fa-caret-down"></i></button>
                                            </div>
                                        </div>
                                        <!-- <form id="" action="">
                                            <div class="form-group">
                                                <input class="form-control" type="number" v-model="be.quantity" name="date" min="1" step="1" @input="changeQuantity(be)">
                                            </div>
                                        </form> -->
                                    </div>
                                    <!-- <div class="new_db_txt">
                                        <div class="new_db_txt_box">
                                            <p>db</p>
                                        </div>
                                    </div> -->
                                </div>
                                <div class="col-sm-2">
                                    <div class="thm_btn_boxes">
                                        <div class="ozz_btn text-center">
                                            <p>{{be.priceTotal && be.priceTotal.toLocaleString('hu')}} Ft</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="thm_btn_boxes">
                                        <div class="kedvenciam_all_quantity_small_title">
                                            <p>Tömeg: {{be.productExtra.grossWeight /1000}} kg</p>
                                            <p>Költség: {{(be.priceTotal + be.productExtra.additionalPrice).toLocaleString('hu')}} Ft</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="kedvenciam_all_area">
                    <div class="col-sm-12">
                        <div class="single_kedvenciam_all again_bg">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="termekek_title again">
                                        <p class="new_rester">Termékek összesen: </p>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="total_termekek_results text-right">
                                        <p class="res_ter bl_red">
                                            {{basket.priceTotal && basket.priceTotal.toLocaleString('hu')}} (net.: {{(basket.priceTotal / 1.27).toFixed(0).toLocaleString('hu')}}) Ft
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="kedvenciam_all_area">
                    <div class="col-sm-12">
                        <div class="single_kedvenciam_all again_bg">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="termekek_title again">
                                        <p class="new_rester">Csomag tömege: </p>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="total_termekek_results text-right">
                                        <!-- <p>
                                            Nettó tömeg: {{basket.productExtra.netWeight}} g
                                        </p> -->
                                        <p v-if="basket.productExtra">
                                            Bruttó tömeg: {{basket.productExtra.grossWeight /1000}} kg
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="kedvenciam_all_area">
                    <div class="col-sm-12">
                        <div class="single_kedvenciam_all again_bg">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="termekek_title again">
                                        <p class="new_rester">Csomag teljes ára (termék + göngyöleg): </p>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="total_termekek_results text-right">
                                        <p class="res_ter bl_red">
                                            {{basket.priceTotalWithPackage && basket.priceTotalWithPackage.toLocaleString('hu')}} (net.: {{(basket.priceTotalWithPackage / 1.27).toFixed(0).toLocaleString('hu')}}) Ft
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="kedvenciam_all_area">
                    <div class="col-sm-12">
                        <div class="single_kedvenciam_all again_bg">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="termekek_title again">
                                        <p class="new_rester">Szállítási díj (csak kiszállításnál): </p>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="total_termekek_results text-right">
                                        <p class="res_ter bl_red">
                                            {{(basket.priceTotalWithShipping-basket.priceTotalWithPackage).toLocaleString('hu')}} Ft
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="basket.basketElements.length>0">
                <div class="kedvenciam_all_area">
                    <div class="col-sm-12">
                        <div class="single_kedvenciam_all again_bg_secnd">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="thm_last_btn text-right">
                                        <router-link tag="a" to="/checkout/basket">RENDELÉS</router-link>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>

        <promoted></promoted>

    </div>
</template>

<script>
import JS from './Basket.js'
import Promoted from '@pages/list/Promoted.vue'

export default{
    mixins:[JS],
    components:{
        Promoted
    },
}

</script>

<style>
.bin_image img{
    cursor: pointer;
}
.kedvenciam_all_small_can {
    text-align: right;
}
.kedvenciam_all_small_can img{
    width: 50%;
}
/*Spinner*/
.spinner {
  width: 100px;
}
.spinner input {
  text-align: right;
}
.input-group-btn-vertical {
  position: relative;
  white-space: nowrap;
  width: 1%;
  vertical-align: middle;
  display: table-cell;
}
.input-group-btn-vertical > .btn {
  display: block;
  float: none;
  width: 100%;
  max-width: 100%;
  padding: 8px;
  margin-left: -1px;
  position: relative;
  border-radius: 0;
}
.input-group-btn-vertical > .btn:first-child {
  border-top-right-radius: 4px;
}
.input-group-btn-vertical > .btn:last-child {
  margin-top: -2px;
  border-bottom-right-radius: 4px;
}
.input-group-btn-vertical i{
  position: absolute;
  top: 0;
  left: 4px;
}
</style>



// WEBPACK FOOTER //
// Basket.vue?7db1cc50